// Groups tab keys by `categoryConfig` ([{ title, tabs: [key] }]), in config order; keys not listed there land in a
// trailing "More" group, and empty groups are dropped. Without a config every key goes into one untitled group.
export const buildMenuCategories = (tabKeys, categoryConfig, getItem) => {
  if (!categoryConfig) return tabKeys.length ? [{ tabs: tabKeys.map(getItem) }] : [];
  const categorized = new Set(categoryConfig.flatMap(category => category.tabs));
  return [
    ...categoryConfig.map(category => ({
      title: category.title,
      tabs: category.tabs.filter(key => tabKeys.includes(key)),
    })),
    { title: 'More', tabs: tabKeys.filter(key => !categorized.has(key)) },
  ]
    .filter(category => category.tabs.length > 0)
    .map(category => ({ ...category, tabs: category.tabs.map(getItem) }));
};
